import React from 'react';
import { motion } from 'framer-motion';
import { Moon, Utensils, Dumbbell, Wind } from 'lucide-react';
const locks = [{
  icon: Moon,
  title: 'Sleep Lock',
  description: 'Morning light, caffeine cutoff, one wind down action'
}, {
  icon: Utensils,
  title: 'Protein Lock',
  description: 'Anchor meals that reduce cravings and decision fatigue'
}, {
  icon: Dumbbell,
  title: 'Lift Lock',
  description: 'Three simple strength sessions per week, with a fatigue system for hard weeks'
}, {
  icon: Wind,
  title: 'Bloat Lock',
  description: 'A trigger rotation that stops the daily panic and helps you identify what is actually happening'
}];
export function MechanismSection() {
  return <section className="w-full px-6 py-20 md:py-28 bg-cream-50" data-id="element-83">
      <div className="max-w-4xl mx-auto" data-id="element-84">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-85">
          <h2 className="font-serif text-3xl md:text-4xl text-stone-800 mb-4" data-id="element-86">
            The 4 Lock Sequence
          </h2>
          <p className="text-lg text-stone-600 italic font-serif" data-id="element-87">
            A door with four locks. Stop pulling the handle. Here are the keys.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-88">
          {locks.map((lock, index) => <motion.div key={lock.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-8 rounded-xl border border-cream-200 shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-89">
              <div className="flex items-start space-x-4" data-id="element-90">
                <div className="flex-shrink-0 p-3 bg-cream-100 rounded-full text-terracotta" data-id="element-91">
                  <lock.icon className="w-6 h-6" data-id="element-92" />
                </div>
                <div data-id="element-93">
                  <h3 className="font-serif text-xl text-stone-800 mb-2 font-medium" data-id="element-94">
                    {lock.title}
                  </h3>
                  <p className="text-stone-600 leading-relaxed" data-id="element-95">
                    {lock.description}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}